/**
 * @description Used to convert an enum value (upper snake case) to title case
 * Examples: AMENDMENT -> Amendment, S_CORP -> S Corp, 1040 -> 1040, etc.
 */
export const convertEnumToTitleCase = (value) => {
  return value
    .split('_')
    .map((word) => {
      if (!word) {
        return '';
      }
      // Convert to title case
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};
